import { normalizeRelativePath } from './normalizeRelativePath.js';

/**
 * @deprecated Use `normalizeRelativePath`.
 */
export function safeRelativePath(originalPath: string | undefined): string {
  return normalizeRelativePath(originalPath);
}
